module.exports = __webpack_public_path__ + "img/req_shou_bg.060a5c63.png";